angular.module('core')
  .service('geographyApi', ['$filter', 'cancelableResourceFactory', '$state', 'highlightsApi', 'transformResponse', 'timeframe', function ($filter, $cancelableResourceFactory, $state, $highlightsApi, $transformResponse) {
    var self = this;

    var geographyMapping = function(geography) {};

    var RegionManagement = $cancelableResourceFactory.createCacheableResource('RegionManagement', '/m/regions', {id: '@id'},
    {
      query: {
        url: '/m/regions',
        method: 'GET',
        isArray: true,
        transformResponse: function(body) {
          return $transformResponse.transformGeographyQuery('region', body, geographyMapping);
        }
      },
      get: {
        url: '/m/regions?country=:country',
        method: 'GET',
        isArray: true,
        transformResponse: function(body) {
          return $transformResponse.transformGeographyGet('region', body, geographyMapping);
        }
      }
    });

    var CountryManagement = $cancelableResourceFactory.createCacheableResource('CountryManagement', '/m/countries', {id: '@id'},
        {
          query: {
            url: '/m/countries',
            method: 'GET',
            isArray: true,
            transformResponse: function(body) {
              return $transformResponse.transformGeographyQuery('countrie', body, geographyMapping);
            }
          },
          get: {
            url: '/m/countries',
            method: 'GET',
            isArray: false,
            transformResponse: function(body) {
              return $transformResponse.transformGeographyGet('countrie', body, geographyMapping);
            }
          }
        });

    /**************************************************************/
    /*                        Navigation Api                      */
    /**************************************************************/

    self.getRegions = function(callback, country) {
      var params = country ? {country: country, id: country} : {};
      var promises = RegionManagement.query(params);
      promises.$promise.then(callback);
    };

    self.getCountries = function(callback) {
      var promises = CountryManagement.query({});
      promises.$promise.then(callback);
    };
  }]);
